<!-- 带标题和字数统计的文本域块（入驻说明 / 小故事等整行输入项） -->
<template>
    <div class="textarea-block">
        <div class="tb-head">
            <span class="tb-title">
                <i class="el-icon-edit-outline"></i>
                {{ title }}
            </span>
            <span class="tb-count" :class="{ 'is-full': curLen >= maxlength }">
                {{ curLen }}/{{ maxlength }}
            </span>
        </div>

        <el-input type="textarea" :value="value" @input="v => $emit('input', v)" :placeholder="placeholder"
            :rows="rows" :maxlength="maxlength" resize="none" class="tb-input" />
    </div>
</template>

<script>
export default {
    name: 'TextareaBlock',
    props: {
        // 标题，如「彩票代表入驻个人说明」
        title: { type: String, default: '' },
        value: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        maxlength: { type: Number, default: 500 },
        rows: { type: Number, default: 4 },
    },
    computed: {
        curLen() {
            return (this.value || '').length
        },
    }
};
</script>

<style lang="scss" scoped>
.textarea-block {
    width: 100%;
    margin-bottom: 22px;
    background: #fff;
    border: 1px solid #e4eaf2;
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.25s ease;

    &:hover {
        border-color: #a9cbf5;
        box-shadow: 0 4px 14px rgba(21, 101, 216, 0.08);
    }

    &:focus-within {
        border-color: #1565d8;
        box-shadow: 0 4px 16px rgba(21, 101, 216, 0.14);
    }

    // 头部：标题 + 字数
    .tb-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 14px;
        background: linear-gradient(90deg, #f4f9ff 0%, #fbfdff 100%);
        border-bottom: 1px solid #edf2f8;

        .tb-title {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 14px;
            font-weight: 600;
            color: #2b3b52;

            i {
                color: #1565d8;
                font-size: 15px;
            }
        }

        .tb-count {
            font-size: 12px;
            color: #a8b4c4;
            font-variant-numeric: tabular-nums;

            &.is-full {
                color: #f56c6c;
            }
        }
    }

    // 输入区
    ::v-deep .tb-input {
        .el-textarea__inner {
            border: none;
            border-radius: 0;
            padding: 12px 14px;
            font-size: 14px;
            line-height: 1.7;
            color: #3d4d63;
            background: transparent;

            &::placeholder {
                color: #b6c2d1;
            }

            &:focus {
                border: none;
                box-shadow: none;
            }
        }
    }
}
</style>
